import React from 'react';

export function Footer() {
  const socialLinks = [
    { label: "Email", href: "mailto:[PARTNER FILLS — e.g., abu@leadcons.com]" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/md-abu-musa-b1700023b/", external: true },
    { label: "Facebook", href: "https://www.facebook.com/abu.musa.415608", external: true },
    { label: "Book a call", href: "#book" }
  ];

  return (
    <footer className="bg-paper border-t border-hairline py-12">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 font-mono text-caption text-graphite uppercase">
          <div className="text-center md:text-left">
            Leadcons by Md Abu Musa  &nbsp;·&nbsp;  Lead generation consultancy  &nbsp;·&nbsp;  © 2026
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2">
            {socialLinks.map((link, idx) => (
              <React.Fragment key={link.label}>
                <a 
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noopener noreferrer" : undefined}
                  className="hover:text-ink transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm animated-underline h-5 flex items-center"
                >
                  {link.label}
                </a>
                {idx < socialLinks.length - 1 && (
                  <span className="text-hairline select-none">·</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}